<template>
    <div id="js-user-wrap" class="container">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="box-card-title">订单记录</span>
                <router-link to="/home">
                    <el-button size="small" type="primary" class="return-button">返回首页</el-button>
                </router-link>
                <div class="tips2">请在创建订单后五分钟内进行支付，否则订单失效；若订单出现异常，请联系联盟工作人员 {{systemConfig.telPhone}} 处理。</div>
                <div class="tips">请在开票链接中备注真实姓名，如无备注，将无法开具发票，提交开票信息后发票将于5个工作日发送至邮箱。</div>
            </div>
            <el-table :data="orderList" style="width: 100%">
                <el-table-column fixed fit prop="orderNo" label="订单编号"  width="290" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="180" align="center"></el-table-column>
<!--                <el-table-column prop="payChannel" label="支付方式" width="80" align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span  v-if="scope.row.payChannel === 1">支付宝</span>-->
<!--                        <span  v-if="scope.row.payChannel === 2">微信</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="body" label="标识" align="center" width="280"></el-table-column>
                <el-table-column prop="totalAmount" label="金额（元）" width="100" align="center"></el-table-column>
                <el-table-column prop="payUrl" label="付款二维码" width="170" align="center">
                    <template slot-scope="scope">
                        <vue-qr v-if="scope.row.tradeState === 2" :logoSrc="scope.row.payChannel === 1?'/alipay.png':'/wxpay.png'"  :text="scope.row.payUrl" :size="150" :margin="0" ></vue-qr>
                        <span v-if="scope.row.tradeState != 2">已失效</span>
                        <!-- <vue-qr :logoSrc="scope.row.payChannel === 1?'/alipay.png':'/wxpay.png'"  :text="scope.row.payUrl" :size="150" :margin="0" ></vue-qr> -->
                    </template>
                </el-table-column>
                <el-table-column prop="tradeState" label="订单状态" width="90" align="center">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.tradeState === 1">无效订单</span>
                        <span  v-if="scope.row.tradeState === 2" style="color:#f01414;">等待支付</span>
                        <span  v-if="scope.row.tradeState === 3">支付成功</span>
                        <span  v-if="scope.row.tradeState === 4">支付失败</span>
                        <span  v-if="scope.row.tradeState === 5">申请退款</span>
                        <span  v-if="scope.row.tradeState === 6">退款成功</span>
                        <span  v-if="scope.row.tradeState === 7">退款失败</span>
                        <span  v-if="scope.row.tradeState === 8">订单异常</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="left">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.tradeState == 2" @click="closeOrder(scope.row.orderId)"  size="small" type="danger">取消</el-button>
                        <el-button v-if="scope.row.tradeState == 3" @click="applyInvoice()"  size="small" type="primary">申请发票</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @current-change="getData" @size-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber"></el-pagination>
        </el-card>
    </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
    components:{VueQr},
    data:()=>{
        return {
            orderList:[],
            searchParam:{
                pageNum:1, 
                pageSize:20
            },
            totalNumber:0,
            loopQueryList:[],
        };
    },
    created() {
        this.getData();
    },
    computed: {
        systemConfig : function () {
            return this.$store.state.systemConfig;
        },
    },
    methods: {
        async getData() { 
            let res = await this.$axios.post('/order/selectByPage',this.searchParam);
            if (res.code == 200) {
                this.orderList = res.data.list;                  //订单列表
                this.totalNumber = res.data.total;
                for(let i = 0; i < this.orderList.length; i++) {
                    if (this.orderList[i].tradeState == 2) {     //如果订单是等待付款状态，加入轮询集合
                        this.loopQueryOrderState(this.orderList[i].orderId);
                    }
                }
            }
        },
        async closeOrder(orderId) {
            let res = await this.$axios.get(`/order/closeOrder/${orderId}`);
            if (res.code == 200) {
                this.$notify({
                    title: '取消成功',
                    message: '你有一笔订单取消成功了！',
                    type: 'success'
                });
                this.getData();
            } else if (res.code == 602) {
                this.$confirm(`${res.errMsg}`,'取消订单错误', {
                    cancelButtonText: '关闭',
                    showClose: false,
                    showConfirmButton: false,
                    type: 'warning'
                }).then(() => {
                    this.getData();
                }).catch(()=>{
                    this.getData();
                });
            }
        },
        async loopQueryOrderState(orderId) {
            let key = "orderId-"+orderId;
            if (this.loopQueryList[key]) {          //已经在轮询集合，不做任何操作
                return;
            } else {
                this.loopQueryList[key] = orderId;  //不在轮询集合，加入，并发起死循环请求直至状态不为等待付款
            }
            let loopFlag = true;
            while (loopFlag) {
                let res = await this.$axios.get(`/order/loopQueryOrderState/${orderId}`);
                if (res && res.code != 200) {
                    loopFlag = false;               //付款状态不再是等待付款。
                }
                if (res.code == 200 && res.data ==3)  {
                    this.$notify({
                        title: '支付成功',
                        message: '你有一笔订单支付成功了！',
                        type: 'success',
                        duration: 0
                    });
                    loopFlag = false;
                    this.getData();
                }
                if (res.code == 200 && res.data ==4)  {
                    this.$notify({
                        title: '支付失败',
                        message: '你有一笔订单支付失败了！',
                        type: 'success',
                        duration: 0
                    });
                    loopFlag = false;
                    this.getData();
                }
            }
        },
        applyInvoice() {
            // window.open("https://csagcr2021.mikecrm.com/MjHk5aD");
            window.open("http://webinv.51fapiao.cn:8020/H5Smkpgl/front/smkpsl/smkp.action?AA00MDEjNWI2MzU4ZjItZmQ1Yy00ZWRhLTg2MzMtZGY4YjE5NjQ1ZjYy=");
        }
    },
    mounted() {

    }
};
</script>


<style scoped>
.tips{
    color:#f01414;
    font-size: 14px;
    margin-top: 7px;
}
.tips2{
    font-size: 14px;
    margin-top: 7px;
}
.container {
    margin-left: auto;
    margin-right: auto;
    max-width: 1300px;
}
.box-card {
    width: 100%;
    margin-top: 10px;
}
.el-input {
    width: 80%;
}
.return-button {
    float: right;
    margin-left: 20px;
}
@media screen and (max-width: 767px) {
    .el-card {
        box-shadow: none;
        border: none;
    }
}
</style>
